import ADD_HOME_VIDEO from "./addHomeVideo"
import DELETE_HOME_VIDEO from "./deleteHomeVideo"
import GENERATE_SCREENSHOT_METADATA_FIELD from "./generateScreenshotMetadataField"
import UPDATE_HOME_VIDEO from "./updateHomeVideo"

export default {
  ADD_HOME_VIDEO,
  DELETE_HOME_VIDEO,
  GENERATE_SCREENSHOT_METADATA_FIELD,
  UPDATE_HOME_VIDEO
}
